import { Tab, Nav, Fade } from 'react-bootstrap'
import stringHelpers from '../../utilities/stringHelpers';
import arrayUtilities from '../../utilities/arrayUtilities';
import formUtilities from '../../utilities/formUtilities';

export const ClientSiteTabbed = (
    { onTabChange, clients, client, setClient, sites, site, setSite, anprCameras, anprCameraId, setAnprCameraId, siteGroups, siteGroup, setSiteGroup, roi, setRoi, activeKey="global", labelWidthClass="col-md-3 col-12", fieldWidthClass="col-md-6 col-12", isClientOrClientManager, assignedSiteIds, assignedSiteGroupIds, hideSiteSubdivisions=false }
) => {
    const restrictedClientIds = arrayUtilities.isNullOrEmpty(assignedSiteIds) || arrayUtilities.isNullOrEmpty(sites)
        ? []
        : sites.filter(x => assignedSiteIds.includes(x.id)).map(x => x.clientId);
    const clientOptions = isClientOrClientManager && !arrayUtilities.isNullOrEmpty(clients)
        ? clients.filter(x => !restrictedClientIds.includes(x.id))
        : clients;
    const showClientTab = !isClientOrClientManager || (arrayUtilities.isNullOrEmpty(assignedSiteGroupIds) && !arrayUtilities.isNullOrEmpty(clientOptions));

    return (
        <Tab.Container defaultActiveKey={activeKey} transition={ Fade } onSelect={ e => onTabChange(e) }>
            <div className="row align-items-center">
                <h6 className={`m-0 fs-1 ${labelWidthClass}`}>Client/Site Details</h6>
                <Nav variant='pills' className={`pl-3 site-client-tabnav ${fieldWidthClass}`}>
                    <div className='d-flex w-fit rounded-md'>
                        {!isClientOrClientManager && <Nav.Item className='px-2 py-1 cursor-pointer'>
                            <Nav.Link className='text-secondary' eventKey='global'>
                                <i className='fas fa-globe-americas mr-2'></i>
                                Global
                            </Nav.Link>
                        </Nav.Item>}
                        {showClientTab && <Nav.Item className='px-2 py-1 cursor-pointer'>
                            <Nav.Link className='text-secondary' eventKey='client'>
                                <i className='fas fa-user-shield mr-2'></i>
                                Client
                            </Nav.Link>
                        </Nav.Item>}

                        <Nav.Item className='px-2 py-1 cursor-pointer'>
                            <Nav.Link className='text-secondary' eventKey='site'>
                                <i className='fas fa-map-marker-alt mr-2'></i>
                                Site
                            </Nav.Link>
                        </Nav.Item>
                    </div>
                </Nav>
            </div>
            <Tab.Content className='mt-2'>
                {!isClientOrClientManager && 
                <Tab.Pane eventKey="global" style={{height: "40px"}}>
                    <div className='row'>
                        <div className={labelWidthClass}></div>
                        <div className={fieldWidthClass}>All Sites</div>
                    </div>
                </Tab.Pane>}
                {showClientTab &&
                <Tab.Pane eventKey="client">
                    <div className="row">
                        <div className={labelWidthClass}>
                            <p className="font-weight-semi-bold  mt-1 mb-1 text-left">Name<span className="req"></span></p>
                        </div>
                        <div className={fieldWidthClass}>
                            <div className="form-group mb-1">
                                <select onChange={(e) => setClient(clientOptions.find(x => x.id === e.target.value)?.id)} className="w-100 border rounded py-1 px-3 form-control">
                                {
                                    isClientOrClientManager ?
                                !arrayUtilities.isNullOrEmpty(clientOptions) && (clientOptions.length > 1 || client !== clientOptions[0].id) && <option value="">Select a client</option>
                                : <option value="">Select a client</option>
                                }
                                {
                                    !arrayUtilities.isNullOrEmpty(clientOptions) && clientOptions.map(item => <option key={item.id} selected={client === item.id} value={item.id}>{item.name}</option>) 
                                }
                            </select>
                            </div>
                        </div>
                    </div>
                </Tab.Pane>}
                <Tab.Pane eventKey="site">
                    <div className="row">
                        <div className={labelWidthClass}>
                            <p className="font-weight-semi-bold  mt-1 mb-1 text-left">Name<span className="req"></span></p>
                        </div>
                        <div className={fieldWidthClass}>
                            {!arrayUtilities.isNullOrEmpty(sites) && setSite ? <div className="form-group mb-1">
                                <select required onChange={(e) => {
                                    setSite(sites.find(x => x.id === e.target.value))
                                    if (activeKey === "site") {
                                        formUtilities.requiredField(e.target.parentNode, e.target.value)
                                    }
                                }} className="w-100 border rounded py-1 px-3 form-control">
                                    {/* needs validation when select is clicked */}
                                    {isClientOrClientManager && !arrayUtilities.isNullOrEmpty(assignedSiteIds) &&
                                        <option value={undefined}>Select</option>
                                    }
                                    {(!isClientOrClientManager || arrayUtilities.isNullOrEmpty(assignedSiteIds)) && 
                                        <option value={null}>All</option>
                                    }   
                                    {
                                        !arrayUtilities.isNullOrEmpty(sites) && sites.map(item => <option key={item.id} selected={site && site.id === item.id} value={item.id}>{item.name}</option>) 
                                    }
                                </select>
                                <small className='invalid-feedback text-danger'>Please select a site</small>
                            </div> : <>{site && site.name}</>
                            }
                        </div>
                    </div>
                    {site && site !== null && !hideSiteSubdivisions &&
                        <>
                            {setAnprCameraId && <div className="row">
                                <div className={labelWidthClass}>
                                    <p className="font-weight-semi-bold  mt-1 mb-1 text-left">ANPR Camera</p>
                                </div>
                                <div className={fieldWidthClass}>
                                    <div className="form-group mb-1">
                                        <select className="w-100 border rounded py-1 px-3 form-control" onChange={ e => setAnprCameraId(e.target.value) }>
                                            <option value={ null }>None</option>
                                            {
                                                !arrayUtilities.isNullOrEmpty(anprCameras) && anprCameras.map(item =>
                                                    <option value={ item.id } selected={ anprCameraId && anprCameraId === item.id }>{ item.name }</option>
                                                )
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>}
                            <div className="row">
                                <div className={labelWidthClass}>
                                    <p className="font-weight-semi-bold  mt-1 mb-1 text-left">Site Group</p>
                                </div>
                                <div className={fieldWidthClass}>
                                    <div className="form-group mb-1">
                                        <select className="w-100 border rounded py-1 px-3 form-control" onChange={ e => setSiteGroup(e.target.value) }>
                                            {((isClientOrClientManager && arrayUtilities.isNullOrEmpty(siteGroups)) || !isClientOrClientManager) && <option value={ "" }>None</option>}
                                            {isClientOrClientManager && !arrayUtilities.isNullOrEmpty(siteGroups) && <option value="">Select</option>}
                                            {
                                                !arrayUtilities.isNullOrEmpty(siteGroups) && siteGroups.map(item =>
                                                    <option value={ item.id } selected={ !stringHelpers.isNullOrEmpty(siteGroup) && siteGroup === item.id }>{ item.name }</option>
                                                )
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className={labelWidthClass}>
                                    <p className="font-weight-semi-bold  mt-1 mb-1 text-left">Bay</p>
                                </div>
                                <div className={fieldWidthClass}>
                                    <div className="form-group mb-0">
                                        <input className="form-control mb-1" type="text" value={roi} onChange={(e) => setRoi(e.target.value)} />
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </Tab.Pane>
            </Tab.Content>
        </Tab.Container>
    )
}